import headerImgEn from "assets/images/v57-nd/header-en.webp"
import infoImgEn from "assets/images/v57-nd/info-en.webp"

export const v57ndConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
